import postMetricsEvents, {
  MetricsEventInput,
  PostMetricsEventsResponse,
} from '../api/postMetricsEvents';
import { APIError, NetworkError } from '../api/apiRequest';
import * as authStore from '../stores/authStore';
import * as userStore from '../stores/userStore';

export type TrackMetricsEventInput = Omit<
  MetricsEventInput,
  'sessionID' | 'organizationID' | 'interface'
> & {
  sessionID?: string;
  organizationID?: string;
  /** Defaults to `ui` for frontend emits. */
  interface?: MetricsEventInput['interface'];
};

/**
 * Emit a Metrics event via user-api, filling sessionID from the working
 * session and organizationID from userStore when not provided.
 *
 * Returns the same { data, error } shape as other common API helpers —
 * callers should generally ignore failures so UX is not blocked on analytics.
 */
export async function trackMetricsEvent(
  event: TrackMetricsEventInput,
): Promise<{
  data?: PostMetricsEventsResponse;
  error?: APIError | NetworkError;
}> {
  authStore.touchWorkingSessionActivity();

  const sessionID = event.sessionID ?? authStore.state.workingSessionID!;

  const organizationID =
    event.organizationID?.trim() ||
    userStore.state.userInfo.organizationID?.trim() ||
    undefined;

  return postMetricsEvents({
    events: [
      {
        interface: 'ui',
        ...event,
        sessionID,
        ...(organizationID ? { organizationID } : {}),
      },
    ],
  });
}
